var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuoteicon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "#4690FF",
  rx: 36
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.107 33.91v15.44h15.44V33.91H23.255c0-5.675 4.618-10.293 10.294-10.293V18.47c-8.515 0-15.44 6.926-15.44 15.44M54.135 23.617V18.47c-8.515 0-15.44 6.926-15.44 15.44v15.44h15.44V33.91H43.84c0-5.675 4.618-10.293 10.294-10.293"
})));
export default SvgQuoteicon;